"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseGetDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class BaseGetDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(this, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.BaseGetDTO = BaseGetDTO;
